import { isFutureVisitAtIso } from "@/components/handshake/visitAt";
import type { BookingListRow } from "./bookingViewModel";
import {
  showPartnerManualReceiptAmount,
  showPartnerReceiptUpload,
} from "./sellerBookingRules";
import type {
  BookingActionCategory,
  BookingLifecycleStatus,
  HandshakeSessionStatus,
} from "@/types";

/**
 * Per-card action rules. Counting and filtering by bucket happen server-side
 * (`GET /bookings/attention`, `GET /bookings/page?action=`) with the same rules.
 */
export const BOOKING_ACTION_CATEGORIES: readonly BookingActionCategory[] = [
  "CONFIRMATION",
  "RECEIPT",
  "COMPLETION",
];

/** Live handshake request waiting on the partner (booking + session both open). */
export function isNewPartnerBooking(
  status: BookingLifecycleStatus,
  handshakeStatus: HandshakeSessionStatus | null,
): boolean {
  return status === "PENDING_HANDSHAKE" && handshakeStatus === "PENDING";
}

export function needsConfirmation(row: BookingListRow): boolean {
  return isNewPartnerBooking(row.status, row.handshakeStatus);
}

export function needsReceiptAction(row: BookingListRow): boolean {
  return showPartnerReceiptUpload(row) || showPartnerManualReceiptAmount(row);
}

export function needsCompletion(row: BookingListRow): boolean {
  if (row.status !== "ACCEPTED") {
    return false;
  }
  if (isFutureVisitAtIso(row.visitAt)) {
    return false;
  }
  if (needsReceiptAction(row)) {
    return false;
  }
  return true;
}
